import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClientsService } from "../services/clients";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { ROUTE_CLIENTS } from "../../SharedModule/utils/constants";
import { useNavigate } from "react-router";
import {
  IsLoadingDropdownInfo,
  loadDropdownInfo,
  SelectDropdownsInfo,
  setIsLoadingDropdownInfo,
} from "../redux/reducers/clientDropdownsInfo.reducer";
import { UsersService } from "../../UsersModule/services/users";
import {
  IsAllUsersWithProfileLoaded,
  IsAllUsersWithProfileLoading,
  loadAllUsersWithProfile,
  SelectAllUsersWithProfileInfo,
  setAllUsersWithProfileLoading,
} from "../redux/reducers/clientsList.reducer";

export const useClientNewClient = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userRolesList, rolesLoaded } = useSelector(selectUserRoles);
  const dropdownsValues = useSelector(SelectDropdownsInfo);
  const isLoadingDropdownInfo = useSelector(IsLoadingDropdownInfo);

  const isAllUsersWithProfileLoaded = useSelector(IsAllUsersWithProfileLoaded);
  const isAllUsersWithProfileLoading = useSelector(
    IsAllUsersWithProfileLoading
  );
  const allUsers = useSelector(SelectAllUsersWithProfileInfo);

  const loadNewContactInfo = useCallback(async () => {
    // page info
    if (rolesLoaded && !dropdownsValues) {
      dispatch(setIsLoadingDropdownInfo(true));
      const dropdownsInfo = await ClientsService.getClientsDropdownsInfo()
        .then((response) => {
          return response;
        })
        .catch(() => {
          dispatch(
            addToast({
              mode: "error",
              message:
                "Something wrong happened while getting new client page information.",
            })
          );
          navigate(ROUTE_CLIENTS);
          return true;
        });
      dispatch(loadDropdownInfo(dropdownsInfo.data));
    }
    // load users for client owner dropdown
    if (!isAllUsersWithProfileLoaded) {
      dispatch(setAllUsersWithProfileLoading(true));
      const usersWithProfileInfo = await UsersService.getUsersWithProfileInfo()
        .then((response) => {
          return response;
        })
        .catch(() => {
          dispatch(
            addToast({
              mode: "error",
              message:
                "Something wrong happened while getting users with profile information.",
            })
          );
          navigate(ROUTE_CLIENTS);
          return true;
        });
      dispatch(loadAllUsersWithProfile(usersWithProfileInfo));
    }
  }, [dispatch, rolesLoaded, dropdownsValues, isAllUsersWithProfileLoaded]);

  useEffect(() => {
    loadNewContactInfo();
  }, [loadNewContactInfo]);

  return {
    isLoadingDropdownInfo,
    isAllUsersWithProfileLoading,
    userRolesList,
    rolesLoaded,
    dropdownsValues,
    allUsers,
  };
};
